export const GET_AREAS = "GET_AREAS"
export const GET_AREAS_SUCCESS = "GET_AREAS_SUCCESS"
export const GET_AREAS_FAIL = "GET_AREAS_FAIL"

export const SEARCH_GUILD = "SEARCH_GUILD"
export const SEARCH_GUILD_SUCCESS = "SEARCH_GUILD_SUCCESS"
export const SEARCH_GUILD_FAILURE = "SEARCH_GUILD_FAILURE"

export const ADD_AREA = "ADD_AREA"
export const ADD_AREA_SUCCESS = "ADD_AREA_SUCCESS"
export const ADD_AREA_FAIL = "ADD_AREA_FAIL"

export const GET_CUSTOM_PLANTS = "GET_CUSTOM_PLANTS"
export const GET_CUSTOM_PLANTS_SUCCESS = "GET_CUSTOM_PLANTS_SUCCESS"
export const GET_CUSTOM_PLANTS_FAIL = "GET_CUSTOM_PLANTS_FAIL"

export const UPDATE_AREA = "UPDATE_AREA"
export const UPDATE_AREA_SUCCESS = "UPDATE_AREA_SUCCESS"
export const UPDATE_AREA_FAIL = "UPDATE_AREA_FAIL"

export const SAVE_CUSTOM_PLANT = "SAVE_CUSTOM_PLANT"
export const SAVE_CUSTOM_PLANT_SUCCESS = "SAVE_CUSTOM_PLANT_SUCCESS"
export const SAVE_CUSTOM_PLANT_FAIL = "SAVE_CUSTOM_PLANT_FAIL"

export const UPDATE_CUSTOM_PLANT = "UPDATE_CUSTOM_PLANT"
export const UPDATE_CUSTOM_PLANT_SUCCESS = "UPDATE_CUSTOM_PLANT_SUCCESS"
export const UPDATE_CUSTOM_PLANT_FAIL = "UPDATE_CUSTOM_PLANT_FAIL"

export const DELETE_CUSTOM_PLANT = "DELETE_CUSTOM_PLANT"
export const DELETE_CUSTOM_PLANT_SUCCESS = "DELETE_CUSTOM_PLANT_SUCCESS"
export const DELETE_CUSTOM_PLANT_FAIL = "DELETE_CUSTOM_PLANT_FAIL"

export const DELETE_AREA = "DELETE_AREA"
export const DELETE_AREA_SUCCESS = "DELETE_AREA_SUCCESS"
export const DELETE_AREA_FAIL = "DELETE_AREA_FAIL"

export const GET_OBJECTIVES = "GET_OBJECTIVES"
export const GET_OBJECTIVES_SUCCESS = "GET_OBJECTIVES_SUCCESS"
export const GET_OBJECTIVES_FAIL = "GET_OBJECTIVES_FAIL"

export const SAVE_OBJECTIVES = "SAVE_OBJECTIVES"
export const SAVE_OBJECTIVES_SUCCESS = "SAVE_OBJECTIVES_SUCCESS"
export const SAVE_OBJECTIVES_FAIL = "SAVE_OBJECTIVES_FAIL"

export const GET_USER_GUILDS = "GET_USER_GUILDS"
export const GET_USER_GUILDS_SUCCESS = "GET_USER_GUILDS_SUCCESS"
export const GET_USER_GUILDS_FAIL = "GET_USER_GUILDS_FAIL"

export const CREATE_USER_GUILD = "CREATE_USER_GUILD"
export const CREATE_USER_GUILD_SUCCESS = "CREATE_USER_GUILD_SUCCESS"
export const CREATE_USER_GUILD_FAIL = "CREATE_USER_GUILD_FAIL"

export const UPDATE_USER_GUILD = "UPDATE_USER_GUILD"
export const UPDATE_USER_GUILD_SUCCESS = "UPDATE_USER_GUILD_SUCCESS"
export const UPDATE_USER_GUILD_FAIL = "UPDATE_USER_GUILD_FAIL"

export const DELETE_USER_GUILD = "DELETE_USER_GUILD"
export const DELETE_USER_GUILD_SUCCESS = "DELETE_USER_GUILD_SUCCESS"
export const DELETE_USER_GUILD_FAIL = "DELETE_USER_GUILD_FAIL"

